import React, { useEffect, useState, useRef } from "react";
import Header from "../component/Header";
import Footer from "../component/Footer";
import { Helmet } from "react-helmet";

const API_PDF_URL = process.env.REACT_APP_API_PDF_URL;
const BASE_URL = process.env.REACT_APP_BASE_URL;

const VotingResult = () => {
  const pageid = 15; // <-- replace with actual pageid for voting results
  const [votingresults, setVotingResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const yearRefs = useRef({});

  useEffect(() => {
    const fetchVotingResults = async () => {
      try {
        const response = await fetch(`${BASE_URL}?pageid=${pageid}`);
        if (!response.ok) throw new Error(`HTTP error! ${response.status}`);
        const result = await response.json();

        if (!result.success || !Array.isArray(result.data)) {
          setVotingResults([]);
          return;
        }

        // Group reports by year
        const grouped = {};
        result.data.forEach((item) => {
          const year = item.year_name;
          if (!grouped[year]) grouped[year] = [];
          grouped[year].push({
            label: item.pdf_name,
            file: item.upload_file_path,
          });
        });

        // Convert grouped object to array and sort descending
        const finalData = Object.keys(grouped)
          .map((year) => ({ year, reports: grouped[year] }))
          .sort((a, b) => b.year - a.year);

        setVotingResults(finalData);
      } catch (error) {
        console.error("Fetch failed:", error);
        setVotingResults([]);
      } finally {
        setLoading(false);
      }
    };

    fetchVotingResults();
  }, []);

  // Scroll to first year
  useEffect(() => {
    if (votingresults.length > 0) {
      const el = yearRefs.current[votingresults[0].year];
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  }, [votingresults]);

  return (
    <>
      <Helmet>
        <title>Voting Results | Nandan Denim Ltd.</title>
      </Helmet>
      <Header />

      {/* Hero Section */}
      <div className="relative w-full">
        <img
          src="./imgs/investors/investorvotingresult.png"
          alt="Chiripal Group Banner"
          className="object-cover w-full h-full md:h-[70vh] lg:h-[80vh] xl:h-[88vh]"
        />
        <div className="absolute inset-0 flex items-center">
          <div className="px-4 sm:px-8 md:px-16 lg:px-32">
            <h1 className="text-yellow-400 text-3xl sm:text-5xl md:text-7xl font-montserrat font-bold text-left">
              Voting Results
            </h1>
          </div>
        </div>
      </div>

      {/* PDF Section */}
      <div className="py-12 px-4 max-w-7xl mx-auto font-signika">
        {loading ? (
          <p>Loading voting results...</p>
        ) : votingresults.length === 0 ? (
          <p>No voting results found.</p>
        ) : (
          votingresults.map((yearGroup, index) => (
            <div
              key={index}
              ref={(el) => (yearRefs.current[yearGroup.year] = el)}
              className="mb-10"
            >
              <h2 className="text-2xl font-extrabold text-[#0b3a6a] uppercase mb-4">
                For the Year {yearGroup.year}
              </h2>
              <ul className="list-disc pl-5 text-[#0b3a6a] font-medium space-y-2">
                {yearGroup.reports.map((report, idx) => (
                  <li key={idx}>
                    <a
                      href={`${API_PDF_URL}/${report.file}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:underline"
                    >
                      {report.label}
                    </a>
                  </li>
                ))}
              </ul>
              <hr className="mt-4 border-gray-300" />
            </div>
          ))
        )}
      </div>

      <Footer />
    </>
  );
};

export default VotingResult;
